The application question information of the search result.

This will be a SEEK library question suitable for use in an application questionnaire.
